// extracted by mini-css-extract-plugin
export default {"taskManagerOrdersTableContainer":"AllTasks_taskManagerOrdersTableContainer__Fcdk-","filterInputField":"AllTasks_filterInputField__2jc83"};